import React from 'react';
import styled from 'styled-components';

import { VerticalConfig } from 'utils/vertical';

type LayoutProps = {
  theme: VerticalConfig['theme'];
  children: React.ReactNode;
};

const Container = styled.div`
  /* Base scaffolding for the application */
  color: var(--text-base);
  background-color: var(--background-base);
  /* Needed to style the root div for sticky footer setup */
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  /* Fix background stacking to prevent gradient behind the main background */
  position: relative;
  z-index: 0;
  -webkit-font-smoothing: antialiased;

  /* S4A global styles */
  &.encore-creator-light-theme *::selection {
    background-color: #89c0ff;
  }
`;

export const Layout = ({ theme, children }: LayoutProps) => (
  <Container className={`${theme} encore-layout-themes`}>{children}</Container>
);
